var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6362 12.4645H3.97936V12.4622M28.021 26.1925V19.5356M28.021 19.5356L21.3641 19.5356M28.021 19.5356L23.7798 23.7796C22.4591 25.1028 20.783 26.1066 18.8474 26.6253C12.9792 28.1976 6.94753 24.7152 5.37517 18.8471M26.6255 13.1531C25.0532 7.28497 19.0215 3.80256 13.1533 5.37492C11.2177 5.89359 9.54157 6.89747 8.22087 8.22065L3.97936 12.4622M3.97936 5.80772V12.4622",
    stroke: "#440098",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.31e150dd67f1d4e490a3b5c0fc50adf8.svg";
export { ForwardRef as ReactComponent };